// Auth
export const POST_KRONALY_LOGIN   = "/auth/login";
export const POST_KRONALY_REGISTER  = "/auth/register";
export const POST_KRONALY_VERIFY_REGISTRATION = "/auth/verify-registration";
export const POST_KRONALY_RESEND_REGISTRATION_VERIFICATION =
  "/auth/resend-registration-verification";
export const POST_KRONALY_REFRESH = "/auth/refresh";
export const POST_KRONALY_LOGOUT  = "/auth/logout";
export const POST_KRONALY_IMPERSONATE = "/auth/impersonate";

// Identity
export const GET_ME         = "/me";
export const ME_AVATAR      = "/me/avatar";
export const GET_WORKSPACES = "/workspaces";
/** POST mismo path: crear primer workspace tras verificar email (onboarding). */
export const POST_WORKSPACES = "/workspaces";

// Workspace modules (gestión de qué módulos están activos en cada workspace)
export const GET_WORKSPACE_MODULES = "/workspace/modules";
/** @param {string} moduleKey */
export const workspaceModulePath = (moduleKey) =>
  `/workspace/modules/${encodeURIComponent(moduleKey)}`;

// Workspace access (invitar usuarios, gestionar roles, revocar)
export const GET_WORKSPACE_ACCESS = "/workspace/access";
export const POST_WORKSPACE_ACCESS = "/workspace/access";
/** @param {string} membershipId */
export const workspaceAccessRolePath = (membershipId) =>
  `/workspace/access/${encodeURIComponent(membershipId)}/role`;
/** @param {string} membershipId */
export const workspaceAccessPath = (membershipId) =>
  `/workspace/access/${encodeURIComponent(membershipId)}`;

// Notification preferences (por user+workspace+type)
export const GET_NOTIFICATION_PREFERENCES = "/notifications/preferences";
/** @param {string} type */
export const notificationPreferencePath = (type) =>
  `/notifications/preferences/${encodeURIComponent(type)}`;

// Internal documentation acknowledgements
/** @param {string} documentId */
export const internalDocAcknowledgePath = (documentId) =>
  `/documentation/documents/${encodeURIComponent(documentId)}/acknowledge`;
/** @param {string} documentId */
export const internalDocAcknowledgementsPath = (documentId) =>
  `/documentation/documents/${encodeURIComponent(documentId)}/acknowledgements`;

// Internal documentation versioning
/** @param {string} documentId — versión vigente desde la que se sube la siguiente */
export const internalDocVersionsPath = (documentId) =>
  `/documentation/documents/${encodeURIComponent(documentId)}/versions`;

// Membership capabilities (capa 2 del modelo de permisos)
/** @param {string} membershipId */
export const membershipCapabilitiesPath = (membershipId) =>
  `/workspace/access/${encodeURIComponent(membershipId)}/capabilities`;
/** @param {string} membershipId */ /** @param {string} capability */
export const membershipCapabilityPath = (membershipId, capability) =>
  `/workspace/access/${encodeURIComponent(membershipId)}/capabilities/${encodeURIComponent(capability)}`;

// Inspection tokens (acceso remoto para Inspección de Trabajo).
// Solo owner del workspace puede gestionarlos.
export const GET_INSPECTION_TOKENS = "/workspace/inspection-tokens";
export const POST_INSPECTION_TOKENS = "/workspace/inspection-tokens";
/** @param {string} tokenId */
export const inspectionTokenRevokePath = (tokenId) =>
  `/workspace/inspection-tokens/${encodeURIComponent(tokenId)}/revoke`;

// API keys de Integración (Configuración → Integraciones).
// Solo owner/admin del workspace pueden gestionarlas.
export const GET_API_KEYS = "/workspace/api-keys";
export const POST_API_KEYS = "/workspace/api-keys";
/** @param {string} apiKeyId */
export const apiKeyRevokePath = (apiKeyId) =>
  `/workspace/api-keys/${encodeURIComponent(apiKeyId)}/revoke`;

// Workspace invitations
/** @param {string} token */
export const invitationByTokenPath = (token) =>
  `/invitations/${encodeURIComponent(token)}`;
/** @param {string} token */
export const acceptInvitationPath = (token) =>
  `/invitations/${encodeURIComponent(token)}/accept`;
/** @param {string} token */
export const activateInvitationPath = (token) =>
  `/invitations/${encodeURIComponent(token)}/activate`;
/** @param {string} invitationId */
export const resendInvitationPath = (invitationId) =>
  `/workspace/invitations/${encodeURIComponent(invitationId)}/resend`;
/** @param {string} invitationId */
export const revokeInvitationPath = (invitationId) =>
  `/workspace/invitations/${encodeURIComponent(invitationId)}`;

// Time Tracking
export const GET_TT_AUDITS     = "/time-tracking/audits";
export const GET_TT_AUDIT_CHAIN_VERIFY = "/time-tracking/audit-chain/verify";
export const POST_CLOCK_IN     = "/time-tracking/clock-in";
export const POST_CLOCK_OUT    = "/time-tracking/clock-out";
export const POST_BREAK_START  = "/time-tracking/break/start";
export const POST_BREAK_END    = "/time-tracking/break/end";
export const GET_TT_STATUS     = "/time-tracking/status";
export const GET_TT_TODAY      = "/time-tracking/today";
export const GET_TT_JORNADA    = "/time-tracking/jornada";

/** @param {string} dateYmd YYYY-MM-DD */
export const ttWorkdayPath = (dateYmd) =>
  `/time-tracking/workdays/${encodeURIComponent(dateYmd)}`;

/** @param {string} dateYmd YYYY-MM-DD */
export const ttWorkdayCorrectionPath = (dateYmd) =>
  `/time-tracking/workdays/${encodeURIComponent(dateYmd)}/corrections`;

export const TT_CORRECTIONS = "/time-tracking/corrections";
/** @param {string} id */
export const ttCorrectionPath = (id) =>
  `/time-tracking/corrections/${encodeURIComponent(id)}`;
/** @param {string} id */
export const ttCorrectionApprovePath = (id) =>
  `/time-tracking/corrections/${encodeURIComponent(id)}/approve`;
/** @param {string} id */
export const ttCorrectionRejectPath = (id) =>
  `/time-tracking/corrections/${encodeURIComponent(id)}/reject`;
/** @param {string} id */
export const ttCorrectionCancelPath = (id) =>
  `/time-tracking/corrections/${encodeURIComponent(id)}/cancel`;

// Jornada especial (intensiva de verano y similares)
export const TT_SPECIAL_SCHEDULES = "/time-tracking/special-schedules";
/** @param {string} id */
export const ttSpecialSchedulePath = (id) =>
  `/time-tracking/special-schedules/${encodeURIComponent(id)}`;
/** @param {string} id */
export const ttSpecialScheduleApprovePath = (id) =>
  `/time-tracking/special-schedules/${encodeURIComponent(id)}/approve`;
/** @param {string} id */
export const ttSpecialScheduleRejectPath = (id) =>
  `/time-tracking/special-schedules/${encodeURIComponent(id)}/reject`;
/** @param {string} id */
export const ttSpecialScheduleCancelPath = (id) =>
  `/time-tracking/special-schedules/${encodeURIComponent(id)}/cancel`;

export const TT_SETTINGS = "/time-tracking/settings";

export const TT_MONTHS = "/time-tracking/months";
/** @param {string} yearMonth YYYY-MM */
export const ttMonthClosePath = (yearMonth) =>
  `/time-tracking/months/${encodeURIComponent(yearMonth)}/close`;

// Reports (background jobs)
export const REPORT_JOBS = "/reports/jobs";
/** @param {string} id */
export const reportJobDownloadPath = (id) =>
  `/reports/jobs/${encodeURIComponent(id)}/download`;

/** Reporte agregado de horas (manager-only). */
export const TT_REPORT_HOURS = "/time-tracking/reports/hours";

/** Reporte agregado de uso de ausencias (manager-only). */
export const ABSENCES_REPORT_USAGE = "/absences/reports/usage";

// Employees (RRHH)
export const GET_EMPLOYEES = "/employees";
/** @param {string} employeeProfileId UUIDv7 */
export const employeePath = (employeeProfileId) =>
  `/employees/${encodeURIComponent(employeeProfileId)}`;
/** @param {string} employeeProfileId UUIDv7 */
export const employeePersonalDetailsPath = (employeeProfileId) =>
  `/employees/${encodeURIComponent(employeeProfileId)}/personal-details`;
/** @param {string} employeeProfileId UUIDv7 */
export const employeeAvatarPath = (employeeProfileId) =>
  `/employees/${encodeURIComponent(employeeProfileId)}/avatar`;
/** @param {string} employeeProfileId UUIDv7 */
export const employeeInvitePath = (employeeProfileId) =>
  `/employees/${encodeURIComponent(employeeProfileId)}/invite`;

// Contracts
export const POST_CONTRACTS = "/contracts";
/** @param {string} contractId UUIDv7 */
export const contractPath = (contractId) =>
  `/contracts/${encodeURIComponent(contractId)}`;
/** @param {string} contractId UUIDv7 */
export const contractTerminatePath = (contractId) =>
  `/contracts/${encodeURIComponent(contractId)}/terminate`;
/** @param {string} contractId UUIDv7 */
export const contractTermsPath = (contractId) =>
  `/contracts/${encodeURIComponent(contractId)}/terms`;
/** @param {string} employeeProfileId UUIDv7 */
export const employeeContractsPath = (employeeProfileId) =>
  `/employees/${encodeURIComponent(employeeProfileId)}/contracts`;
/** @param {string} employeeProfileId UUIDv7 */
export const employeeActiveContractPath = (employeeProfileId) =>
  `/employees/${encodeURIComponent(employeeProfileId)}/contracts/active`;

// Contracts catálogos
export const WORK_SCHEDULES = "/work-schedules";
export const HOLIDAY_GROUPS = "/holiday-groups";
export const holidayGroupPath = (id) => `/holiday-groups/${encodeURIComponent(id)}`;
export const holidayGroupHolidaysPath = (id) =>
  `/holiday-groups/${encodeURIComponent(id)}/holidays`;
export const holidayPath = (id) => `/holidays/${encodeURIComponent(id)}`;
export const VACATION_POLICIES = "/vacation-policies";
export const vacationPolicyPath = (id) => `/vacation-policies/${encodeURIComponent(id)}`;

// Notifications
export const NOTIFICATIONS = "/notifications";
export const NOTIFICATIONS_UNREAD_COUNT = "/notifications/unread-count";
export const NOTIFICATIONS_READ_ALL = "/notifications/read-all";
export const notificationReadPath = (id) => `/notifications/${encodeURIComponent(id)}/read`;
export const notificationPath = (id) => `/notifications/${encodeURIComponent(id)}`;

// Absences
export const ABSENCES = "/absences";
export const absencePath = (id) => `/absences/${encodeURIComponent(id)}`;
export const absenceApprovePath = (id) => `/absences/${encodeURIComponent(id)}/approve`;
export const absenceRejectPath = (id) => `/absences/${encodeURIComponent(id)}/reject`;
export const absenceCancelPath = (id) => `/absences/${encodeURIComponent(id)}/cancel`;
export const employeeAbsenceBalancePath = (empId) =>
  `/employees/${encodeURIComponent(empId)}/absence-balance`;
export const employeeAbsenceAdjustmentsPath = (empId) =>
  `/employees/${encodeURIComponent(empId)}/absence-balance/adjustments`;
export const employeeAbsenceAdjustmentPath = (empId, adjId) =>
  `/employees/${encodeURIComponent(empId)}/absence-balance/adjustments/${encodeURIComponent(adjId)}`;

// Teams
export const TEAMS = "/teams";
export const teamPath = (id) => `/teams/${encodeURIComponent(id)}`;
export const teamMembersPath = (id) => `/teams/${encodeURIComponent(id)}/members`;
export const teamMemberPath = (teamId, empId) =>
  `/teams/${encodeURIComponent(teamId)}/members/${encodeURIComponent(empId)}`;

// Document requests
export const DOCUMENT_REQUESTS = "/document-requests";
export const DOCUMENT_REQUESTS_BULK = "/document-requests/bulk";
export const documentRequestCancelPath = (id) =>
  `/document-requests/${encodeURIComponent(id)}/cancel`;
export const documentRequestFulfillPath = (id) =>
  `/document-requests/${encodeURIComponent(id)}/fulfill`;

// Document categories
export const DOCUMENT_CATEGORIES = "/document-categories";
export const documentCategoryPath = (id) =>
  `/document-categories/${encodeURIComponent(id)}`;

// Documents
export const DOCUMENTS = "/documents";
export const documentPath = (id) => `/documents/${encodeURIComponent(id)}`;
export const documentDownloadPath = (id) =>
  `/documents/${encodeURIComponent(id)}/download`;
export const documentPreviewPath = (id) =>
  `/documents/${encodeURIComponent(id)}/preview`;
export const documentEventsPath = (id) =>
  `/documents/${encodeURIComponent(id)}/events`;
export const documentPublishPath = (id) =>
  `/documents/${encodeURIComponent(id)}/publish`;
export const documentArchivePath = (id) =>
  `/documents/${encodeURIComponent(id)}/archive`;
export const documentUnarchivePath = (id) =>
  `/documents/${encodeURIComponent(id)}/unarchive`;

// Internal Documentation (jerarquía documental corporativa)
export const DOCUMENTATION_LEVELS = "/documentation/levels";
export const documentationLevelPath = (id) =>
  `/documentation/levels/${encodeURIComponent(id)}`;
export const DOCUMENTATION_TYPES = "/documentation/types";
export const documentationTypePath = (id) =>
  `/documentation/types/${encodeURIComponent(id)}`;
export const INTERNAL_DOCUMENTS = "/documentation/documents";
export const internalDocumentPath = (id) =>
  `/documentation/documents/${encodeURIComponent(id)}`;
export const internalDocumentDownloadPath = (id) =>
  `/documentation/documents/${encodeURIComponent(id)}/download`;
export const internalDocumentPreviewPath = (id) =>
  `/documentation/documents/${encodeURIComponent(id)}/preview`;
export const internalDocumentPublishPath = (id) =>
  `/documentation/documents/${encodeURIComponent(id)}/publish`;
export const internalDocumentArchivePath = (id) =>
  `/documentation/documents/${encodeURIComponent(id)}/archive`;
export const internalDocumentUnarchivePath = (id) =>
  `/documentation/documents/${encodeURIComponent(id)}/unarchive`;

// Overtime
export const OVERTIME_REQUESTS = "/overtime/requests";
export const OVERTIME_REQUESTS_MY = "/overtime/requests/my";
export const overtimeCancelPath = (requestId) =>
  `/overtime/requests/${encodeURIComponent(requestId)}/cancel`;
export const overtimeDecidePath = (requestId) =>
  `/overtime/requests/${encodeURIComponent(requestId)}/decide`;
export const OVERTIME_ALLOWANCES = "/overtime/allowances";
export const overtimeAllowanceDeactivatePath = (allowanceId) =>
  `/overtime/allowances/${encodeURIComponent(allowanceId)}/deactivate`;

// Workday incidents
export const WORKDAY_INCIDENTS = "/time-tracking/incidents";
export const workdayIncidentValidatePath = (incidentId) =>
  `/time-tracking/incidents/${encodeURIComponent(incidentId)}/validate`;

// Excess workdays (manager dashboard)
export const EXCESS_WORKDAYS = "/time-tracking/excess-workdays";

// Soporte IT (Help Desk)
export const SUPPORT_META = "/support/meta";
export const SUPPORT_TICKETS = "/support/tickets";
export const supportTicketPath = (id) =>
  `/support/tickets/${encodeURIComponent(id)}`;
export const supportTicketAssignPath = (id) =>
  `/support/tickets/${encodeURIComponent(id)}/assign`;
export const supportTicketStatusPath = (id) =>
  `/support/tickets/${encodeURIComponent(id)}/status`;
export const supportTicketCommentsPath = (id) =>
  `/support/tickets/${encodeURIComponent(id)}/comments`;
export const SUPPORT_CATEGORIES = "/support/categories";
export const supportCategoryPath = (id) =>
  `/support/categories/${encodeURIComponent(id)}`;
// Soporte IT · Inventario
export const SUPPORT_ASSETS = "/support/assets";
export const supportAssetPath = (id) => `/support/assets/${encodeURIComponent(id)}`;
export const supportAssetStatusPath = (id) => `/support/assets/${encodeURIComponent(id)}/status`;
export const supportAssetAssignPath = (id) => `/support/assets/${encodeURIComponent(id)}/assign`;
export const supportAssetReturnPath = (id) => `/support/assets/${encodeURIComponent(id)}/return`;
export const supportAssetMaintenancesPath = (id) => `/support/assets/${encodeURIComponent(id)}/maintenances`;
export const SUPPORT_ASSET_TYPES = "/support/asset-types";
export const supportAssetTypePath = (id) => `/support/asset-types/${encodeURIComponent(id)}`;
export const SUPPORT_CONFIG_TECHNICIANS = "/support/config/technicians";
export const supportConfigTechnicianPath = (membershipId) =>
  `/support/config/technicians/${encodeURIComponent(membershipId)}`;

// Recursos IT
export const SUPPORT_RESOURCES = "/support/resources";
export const supportResourcePath = (id) => `/support/resources/${encodeURIComponent(id)}`;
export const supportResourceStatusPath = (id) => `/support/resources/${encodeURIComponent(id)}/status`;
export const supportResourceAccessPath = (id) => `/support/resources/${encodeURIComponent(id)}/access`;
export const supportResourceAccessMemberPath = (id, employeeProfileId) =>
  `/support/resources/${encodeURIComponent(id)}/access/${encodeURIComponent(employeeProfileId)}`;
export const supportResourceDocumentsPath = (id) => `/support/resources/${encodeURIComponent(id)}/documents`;
export const supportResourceDocumentPath = (id, docId) =>
  `/support/resources/${encodeURIComponent(id)}/documents/${encodeURIComponent(docId)}`;
